import { CurrentUser } from "sdk/currentUser";
import { PlanType } from "sdk/types";
import { useCurrentUser } from "./useCurrentUser";

interface UseSubscriptionPlan {
  plan: PlanType | null;
  user: CurrentUser | null;
}

export const useSubscriptionPlan = (): UseSubscriptionPlan => {
  const user = useCurrentUser();

  if (!user) {
    return { plan: null, user: null };
  }

  const {
    subscription: { plan },
  } = user!;

  return { plan, user };
};
